import { IDynamicSearchableQueryOptions } from "@timesheets/webapp-support";
import { PropOptions } from "vue";
import { getDefaultMergedDynamicQueryOptions } from "../../QueryOptions";

export function getDynamicQueryOptionsProp<TFilter, TDynamicQueryOptions extends IDynamicSearchableQueryOptions<TFilter> = IDynamicSearchableQueryOptions<TFilter>>() {
  return {
    type: Object,
    default: () => getDefaultMergedDynamicQueryOptions<TFilter, TDynamicQueryOptions>({} as TDynamicQueryOptions),
  } as PropOptions<TDynamicQueryOptions>;
}
